// Module
var code = "<gli-body gli-default-img=\"{{ olib.defaultImage }}\" gli-img=\"{{ organisation.image.thumbnail }}\"/>\n";
// Exports
var _module_exports = code;;
var path = 'components/organisation/list/base/ol-item-body.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;